import { useState, useCallback } from 'react';

export function useToolCalls() {
  const [activeToolCalls, setActiveToolCalls] = useState([]);
  const [completedToolCalls, setCompletedToolCalls] = useState([]);

  const handleToolStarted = useCallback((data) => {
    setActiveToolCalls(prev => [...prev, {
      tool_name: data.tool_name,
      display_name: data.display_name,
      parameters: data.parameters,
      timestamp: data.timestamp
    }]);
  }, []);

  const handleToolCompleted = useCallback((data) => {
    setActiveToolCalls(prev => prev.filter(t => t.tool_name !== data.tool_name));
    setCompletedToolCalls(prev => [...prev, {
      id: data.tool_call_id,
      tool_name: data.tool_name,
      display_name: data.display_name,
      success: data.success,
      summary: data.summary,
      resource_cards: data.resource_cards || [],
      creates_resources: data.creates_resources === true,
      awaiting_approval: data.awaiting_approval === true,
      timestamp: data.timestamp
    }]);
  }, []);

  const resetToolCalls = useCallback(() => {
    setActiveToolCalls([]);
    setCompletedToolCalls([]);
  }, []);

  const setInitialToolCalls = useCallback((toolCalls) => {
    if (!toolCalls || toolCalls.length === 0) {
      setActiveToolCalls([]);
      setCompletedToolCalls([]);
      return;
    }

    const active = toolCalls
      .filter(tc => tc.status === 'pending')
      .map(tc => ({
        id: tc.id,
        tool_name: tc.tool_name,
        display_name: tc.display_name,
        parameters: tc.parameters,
        timestamp: tc.created_at
      }));

    const completed = toolCalls
      .filter(tc => tc.status !== 'pending')
      .map(tc => ({
        id: tc.id,
        tool_name: tc.tool_name,
        display_name: tc.display_name,
        success: tc.success,
        summary: tc.summary,
        resource_cards: tc.resource_cards || [],
        creates_resources: tc.creates_resources === true,
        awaiting_approval: tc.awaiting_approval === true,
        timestamp: tc.completed_at || tc.created_at
      }));

    setActiveToolCalls(active);
    setCompletedToolCalls(completed);
  }, []);

  return {
    activeToolCalls,
    completedToolCalls,
    handleToolStarted,
    handleToolCompleted,
    resetToolCalls,
    setInitialToolCalls,
    hasToolCalls: activeToolCalls.length > 0 || completedToolCalls.length > 0
  };
}

export default useToolCalls;
